import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Cargos from '../../../components/rh/cargos';


function HomeCargosScreen () {
    return (
        <Fragment>
            <Head titulo="Área de Cargos | Consórcio LVF" />
            <Header />
            <Cargos />
            <Footer />
        </Fragment>
    );
}

export default HomeCargosScreen;